<template>
  <div class="skyway-loading">
    <div class="loader-wrapper">
      <div class="loader" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SkywayLoading"
}
</script>
